import React from "react";
import { Button, Input, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./ProfileListSearch.css";

export function ProfileListSearch({ search, label, children, colors }) {
  return <div className="profile-list-search-row" style={colors ? {
    "--profile-search-bg": colors.input, "--profile-search-text": colors.text,
    "--profile-search-muted": colors.textSub, "--profile-search-border": colors.border,
    "--profile-search-hover": colors.hover,
  } : undefined}>
    {children}
    <div className={`profile-list-search-control${search.expanded ? " is-expanded" : ""}`}>
      {search.expanded ? <Input autoFocus size="small" prefix={<SearchOutlined />} allowClear aria-label={label} placeholder={label}
        value={search.query} onChange={event => search.setQuery(event.target.value)} onBlur={search.blur} />
        : <Tooltip title={label}><Button size="small" type="text" aria-label={label} icon={<SearchOutlined />} onClick={search.expand} /></Tooltip>}
    </div>
  </div>;
}
